import styled, { css } from "styled-components";

export const StyledChatCard = styled.div`
  ${({ disabled, active }) => css`
    display: grid;
    grid-template-columns: 42px 1fr 70px;
    align-items: center;
    grid-gap: 6px;
    padding: 10px 16px 10px 6px;
    border-bottom: 1px solid #e9ecef;
    cursor: pointer;
    pointer-events: ${disabled ? "none" : "auto"};
    opacity: ${disabled ? 0.5 : 1};
    border-left: 4px solid transparent;
    &:hover {
      border-left: 4px solid #1b84e7;
      background-color: #f5f7fa;
    }
    ${active &&
    css`
      border-left: 4px solid #1b84e7;
      background-color: #f5f7fa;
    `}
  `}
`;

export const StyledAvatar = styled.img`
  width: 42px;
  height: 42px;
  border-radius: 50%;
`;

export const StyledUserInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

export const StyledUserName = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #495057;
`;

export const StyledMessage = styled.div`
  font-weight: 400;
  font-size: 12px;
`;

export const StyledMessageCount = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
`;

export const StyledCount = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  background-color: #1b84e7;
  color: #fff;
  font-weight: 600;
`;

export const StyledDate = styled.div`
  font-size: 11px;
  margin-top: 4px;
  color: #b7bdc3;
`;
